import { useContext } from 'react'

import { APLTranslationCodes } from 'onboarding/configs/translations/aplTranslationCodes'
import { LanguageContext } from 'onboarding/context/LanguageContext'

import { APLHeader } from '../../../commonComponents/aplHeader/APLHeader'

import styles from './APLSearchHeader.module.scss'

export const APLSearchHeader = () => {
  const { t } = useContext(LanguageContext)

  return (
    <APLHeader
      firstSlice={<p className={styles.text}> {t(APLTranslationCodes.welcome_header_title)}</p>}
    />
  )
}
